import React, { useState } from 'react';
import { useRouter, usePathname } from 'next/navigation';
import { cn } from '@/utils/cn';
import SectionDynamicGroup from '@/app/components/SectionDynamicGroup';
import CampaignGroupSectionHeader from '@/app/components/Header/CampaignGroupSectionHeader';
import { useDispatch } from 'react-redux';
import { setSectionGroupItems } from '@/redux/reducers/campaign-products-reducer';
import { EXTERNAL } from '@/constants';
import { getCurrentUrl } from '@/utils/string';

function CampaignDynamicSection({ section }) {
  const router = useRouter();
  const pathname = usePathname();
  const dispatch = useDispatch();
  const [targetEndDate, setTargetEndDate] = useState(
    new Date(section?.details?.timer_end_to),
  );

  const isCampaignLanding = pathname.startsWith('/campaign-landing');

  const handleClick = (e) => {
    dispatch(setSectionGroupItems([section]));
    e.stopPropagation();

    const url = section?.redirect_url?.en?.url;
    const urlText = section?.redirect_url?.en?.text;
    const urlType = section?.redirect_url?.en?.type;

    const currentUrl = getCurrentUrl();

    if (currentUrl === url) {
      return null;
    }

    if (url && urlText) {
      if (urlType === EXTERNAL) {
        window.open(url);
      } else {
        router.push(url);
      }
    }
  };

  const currentDate = new Date();

  const isExpired =
    targetEndDate && currentDate > new Date(section?.details?.timer_end_to);

  if (isExpired) {
    return null;
  }

  return (
    <div
      className={cn(
        'campaign-dynamic-section h-full pt-16 mb-48',
        section?.has_background && !isCampaignLanding ? 'has-background' : '',
        section?.redirect_url?.en?.url &&
          section?.redirect_url?.en?.text &&
          section?.redirect_url?.en?.url !== getCurrentUrl()
          ? 'cursor-pointer'
          : '',
      )}
      style={{
        '--gradient-color-1':
          section?.details?.gradient_color_1 || 'transparent',
        '--gradient-color-2':
          section?.details?.gradient_color_2 || 'transparent',
      }}
      role="presentation"
      onClick={handleClick}
    >
      <div className="sub-section-group-container">
        <CampaignGroupSectionHeader
          section={section}
          hasTimer={section?.has_timer}
          targetStartDate={section?.details?.timer_start_from}
          targetEndDate={section?.details?.timer_end_to}
          topIcon={section?.has_icon ? section?.details?.icon : false}
          showCountDownTimer={section?.has_timer}
        />
        {section?.is_group_section && section?.sub_sections?.length > 0 ? (
          <div
            className="sub-section-group-sections relative flex flex-col"
            role="presentation"
            onClick={(e) => e.stopPropagation()}
          >
            {section?.sub_sections?.map((item) => (
              <div
                key={item?.id}
                role="presentation"
                onClick={(e) => e.stopPropagation()}
              >
                <SectionDynamicGroup
                  section={item}
                  hasParentBG={section?.has_background}
                  hasParentTimer={section?.has_timer}
                  isGroupSection
                />
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default CampaignDynamicSection;
